import { render, staticRenderFns } from "./AIVHorizontalScroll.vue?vue&type=template&id=330afb34&scoped=true"
import script from "./AIVHorizontalScroll.vue?vue&type=script&lang=js"
export * from "./AIVHorizontalScroll.vue?vue&type=script&lang=js"
import style0 from "./AIVHorizontalScroll.vue?vue&type=style&index=0&id=330afb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330afb34",
  null
  
)

export default component.exports